module.exports = {
  __depends__: [
    require(170),
    require(211)
  ],
  contextPad: [ 'type', require(152) ]
};